export default __webpack_public_path__ + "static/media/hambolu.2fa050c8.webp";